import { createStore } from '@store/createStore';

const chatInitialState = {
  chatMessages: [
    {
      content: 'Hello! How can I assist you today?',
      role: 'assistant',
      firstMessage: true,
    },
  ],
  chatId: undefined,
};

const useChatStore = createStore((set) => ({
  ...chatInitialState,
  isOpen: false,

  actions: {
    setChatIsOpen: () =>
      set(({ isOpen }) => {
        return { isOpen: !isOpen };
      }),
    setChatMessages: (newChatMessage) =>
      set(({ chatMessages }) => ({ chatMessages: [...chatMessages, newChatMessage] })),
    setChatId: (chatId) => set({ chatId }),
    setActiveChat: (chatMessages) =>
      set({ chatMessages: [...chatInitialState.chatMessages, ...chatMessages] }),
    setChatClear: () => set({ ...chatInitialState }),
    setMessageHasError: (hasError) =>
      set(({ chatMessages }) => {
        const messagesList = [...chatMessages];
        const lastMessage = messagesList[messagesList.length - 1];
        messagesList[messagesList.length - 1] = { ...lastMessage, hasError };

        return { chatMessages: messagesList };
      }),
  },
}));

export const useChatActions = () => useChatStore((state) => state.actions);

export const selectChatMessages = () => useChatStore((state) => state.chatMessages);
export const selectChatId = () => useChatStore((state) => state.chatId);
export const selectChatIsOpen = () => useChatStore((state) => state.isOpen);
